import { Component, computed } from '@angular/core';
import { FindItemComponent, TableCol } from 'ets-fe-ng-sdk';
import { INotificationReceiver } from '../notification.model';
import { NotificationService as MessageService } from '../notification.service';
import { UtilityService } from '../../../services/utility.service';

@Component({
  selector: 'notification-history',
  imports: [FindItemComponent],
  templateUrl: './notification-history.component.html',
  styleUrl: './notification-history.component.scss',
})
export class NotificationHistoryComponent {
  readonly columns = computed<TableCol<INotificationReceiver>[]>(() => [
    { f: '_title', t: 'Title', formatterRow: (row) => row?._notification?.title || '-' },
    { f: '_body', t: 'Body', formatterRow: (row) => row?._notification?.body || '-' },
    { f: 'read', t: 'Read', formatter: this.uS.yesNoCellFormatter },
    { f: 'createdOn', t: 'Sent On', formatter: this.uS.fullDateTime },
  ]);
  constructor(
    public mS: MessageService,
    public uS: UtilityService,
  ) {}
}
